module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-10.4abe3ef1.png";